jQuery(function ($) {

  $('.nav-collapse ul li .sub-menu-wrap').each(function() {
      var parent_id = $( this ).parent().attr('id');
      $('.megamenu-container').append('<div id="sub-' + parent_id + '" class="sub-menu-container">' + $( this ).html() + '</div>')
  });

  var active_menu_item;

  $('.nav-collapse ul li').hover(function() {
    var elem_name = '#sub-' + $(this).attr('id');
      if ($(window).width() > (991 - 15)) {
        $( elem_name ).show();
      }
  }, function() {
    var elem_name = '#sub-' + $( this ).attr('id');
    $( elem_name ).hide();
  });

  $('.megamenu-container .sub-menu-container').hover(function() {
    if ($(window).width() > (991 - 15)) {
      $( this ).show();
    }
  }, function() {
    $( this ).hide();
  });

    // Enable Magnific Popup for gallery
    $('.gallery').each(function() {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true,
                tCounter: '%curr% / %total%' 
            },
            image: {
                titleSrc: 'title' 
                // this tells the script which attribute has your caption
            }            
        });
    });
});
